<template>

<div class="filter-text-compact" v-if="isCompact && !$isMobile" v-click-outside="onOutsideClick">

	<core-button
		v-if="!hasValue"
		v-on:click.native="onToggleClick"
		theme="filter"
		icon="magnifying-glass"
		:iconOnly="true"
		tooltip="Quick search"
		class="filter-text-compact-button"
	/>

	<core-button
		v-if="hasValue"
		v-on:click.native="onToggleClick"
		theme="filter"
		icon="magnifying-glass"
		:iconOnly="true"
		:tooltip="'Quick search: ' + value"
		class="filter-text-compact-button has-value"
	/>

	<div v-if="is.expanded" class="filter-text-compact-popover">

		<core-filter-input-text
			v-on:ready="onExpandedReady"
			:filter="filter"
			placeholder="Quick search..."
			class="filter-text filter-text-expanded"
		/>

	</div>

</div>

<core-filter-input-text v-else v-on:ready="onReady" :filter="filter" placeholder="Quick search..." class="filter-text" />

</template>

<script>

import vClickOutside from 'v-click-outside'
import barRightState from './bar/state'

export default {

	directives: {
		clickOutside: vClickOutside.directive
	},

	props: [
		'filter'
	],

	data: function() {

		return {
			el: false,
			is: {
				expanded: false
			}
		}

	},

	computed: {

		isCompact: function() {

			return barRightState.text

		},

		value: function() {

			return this.$store.getters['filter/' + this.filter]

		},

		hasValue: function() {

			return this.value && String(this.value).length > 0

		}

	},

	created: function() {

		// Bind once and keep the reference — calling .bind() in both
		// hooks creates a fresh function each time, so the cleanup
		// would never match the listener and a handler would leak
		// for every Text instance ever mounted.
		this.onShortcutBound = this.onShortcut.bind(this)
		window.addEventListener('keydown', this.onShortcutBound)

	},

	beforeDestroy: function() {

		window.removeEventListener('keydown', this.onShortcutBound)

	},

	methods: {

		onShortcut: function(e) {

			if (e.ctrlKey && e.keyCode === 70) {

				e.preventDefault()
				if (this.isCompact && !this.$isMobile) this.is.expanded = true
				this.$nextTick(function() {

					if (this.el) this.el.focus()

				}.bind(this))

			}

		},

		onReady: function(el) {

			this.el = el

		},

		onExpandedReady: function(el) {

			this.el = el
			el.focus()

		},

		onToggleClick: function() {

			this.is.expanded = !this.is.expanded

		},

		onOutsideClick: function() {

			if (!this.hasValue) this.is.expanded = false

		}

	}

}

</script>

<style scoped>

.filter-text  {
	padding: 0px!important;
}

.is-mobile .filter-text {
	position: fixed;
	bottom: 0px;
	left: 0px;
	right: 0px;
}

.filter-text >>> input {
	background-color: #fff!important;
	color: #343434!important;
	font-size: 14px!important;
	padding: 0px 10px!important;
	height: 40px!important;
	border-radius: 4px!important;
	box-shadow: rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
}

.is-mobile .filter-text >>> input {
	border-radius: 0px!important;
}

.filter-text >>> input::placeholder {
	color: #999!important;
	font-style: normal!important;
}

.filter-text-compact {
	display: flex;
	align-items: center;
	position: relative;
}

.filter-text-compact-button {
	padding: 0px 10px!important;
}

.filter-text-compact .has-value >>> .button-icon {
	color: #61c7ff;
}

.filter-text-compact-popover {
	position: absolute;
	top: 100%;
	right: 0px;
	margin-top: 4px;
	z-index: 10;
}

.filter-text-expanded {
	width: 220px;
}

</style>
